module.exports = __webpack_public_path__ + "img/loader.78e826ca.gif";